import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

const ContactForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [phone, setPhone] = useState("");

  const form = useRef();

  const subimtHandler = (e) => {
    e.preventDefault();

    // set them to empty values
    setName("");
    setEmail("");
    setSubject("");
    setMessage("");
    setPhone("");

    emailjs
      .sendForm(
        "service_ym072mc",
        "contact-template",
        form.current,
        "XIJYdEIZ6kSu_lJiT"
      )
      .then(
        (result) => {
          console.log("Email sent");
          // console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <form ref={form} onSubmit={subimtHandler} className="form">
      <div className="row justify-content-center">
        <div className="col-lg-6 col-md-6 col-12">
          <div className="form-field">
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              type="text"
              name="name"
              placeholder="Nom"
              required
            />
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-12">
          <div className="form-field">
            <input
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              type="text"
              name="phone"
              placeholder="Telephone"
              required
            />
          </div>
        </div>
        <div className="col-12">
          <div className="form-field">
            <input
              onChange={(e) => setSubject(e.target.value)}
              value={subject}
              type="text"
              name="subject"
              placeholder="Object"
              required
            />
          </div>
        </div>
        <div className="col-12">
          <div className="form-field">
            <input
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              type="email"
              name="email"
              placeholder="Email"
              required
            />
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-12"></div>
        <div className="col-lg-12">
          <div className="form-field">
            <textarea
              onChange={(e) => setMessage(e.target.value)}
              value={message}
              name="message"
              placeholder="Message"
              required
            ></textarea>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="form-submit">
            <button type="submit" className="theme-btn">
              Envoyer
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default ContactForm;
